import { Button } from "@/components/ui/button";
import { type UseMarqueeCopyReturn } from "@/hooks/useMarqueeCopy";
import { cn } from "@/lib/utils";
import { CheckCircle2Icon } from "lucide-react";

type CopyableContactButtonProps = {
  value: string;
  copiedLabel: string;
  marquee: UseMarqueeCopyReturn;
};

/** Button that copies a value on click and shows a marquee animation on hover when text overflows. */
export function CopyableContactButton({
  value,
  copiedLabel,
  marquee,
}: CopyableContactButtonProps) {
  const { showCopied, textRef, containerRef, startMarquee, stopMarquee, handleCopy } =
    marquee;

  return (
    <Button
      variant="secondary"
      className="rounded-r-none min-w-0"
      size="sm"
      onClick={() => handleCopy(value)}
      onMouseEnter={startMarquee}
      onMouseLeave={stopMarquee}
    >
      <CheckCircle2Icon className="w-4 h-4 mr-2 shrink-0 fill-green-500 text-white" />
      <span ref={containerRef} className="relative overflow-hidden min-w-0">
        <span
          ref={textRef}
          className={cn(
            "inline-block whitespace-nowrap transition-opacity duration-200",
            showCopied ? "opacity-0" : "opacity-100"
          )}
        >
          {value}
        </span>
        <span
          className={cn(
            "absolute inset-0 transition-opacity duration-200",
            showCopied ? "opacity-100" : "opacity-0"
          )}
        >
          {copiedLabel}
        </span>
      </span>
    </Button>
  );
}
